import React, { useEffect, useState } from "react";
import { Table, Button } from "reactstrap";
import ReactReadMoreReadLess from "react-read-more-read-less";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { doRequest } from "../utils/helper";
import Sidebar from "../components/Sidebar";
import AdminFooter from "../components/AdminFooter";

export default function VariantFaq() {
  const [faqList, setFaqList] = useState([]);
  const [faqCount, setFaqCount] = useState(0);
  let history = useNavigate();

  const faqListApi = async () => {
    try {
      let res = await doRequest("", "GET", "faq/list");
      if (+res?.resultFlag === 1) {
        setFaqList(res?.response?.Faq);
        setFaqCount(res?.response?.totalRecords);
      } else {
        setFaqList([]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    faqListApi();
  }, []);
  return (
    <>
      <div className="container-fluid main">
        <Sidebar />

        <section className="home">
          <div className="container-fluid">
            <div className="searcmain_pad">
              <div className="search_header">
                <ul className="search_list">
                  <li>
                    <h3>Teedex FAQs</h3>
                  </li>

                  <li>
                    <div className="cansear_div">
                      <button
                        className="sav_sea sav_ques"
                        onClick={() => {
                          history("/variantfaqedit");
                        }}
                      >
                        Add Question Answer
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="container">
                <div className="table-responsive table_user_mar">
                  <Table hover striped className="table_cust align-middle">
                    <thead className="thead_bg">
                      <th className="userth" style={{ width: "25%" }}>
                        PLAN
                      </th>
                      <th className="userth" style={{ width: "25%" }}>
                        Answer
                      </th>
                      <th className="userth">Date created</th>
                      <th className="userth">Status</th>
                      <th className="userth">Actions</th>
                    </thead>

                    <tbody>
                      {faqList &&
                        faqList.length > 0 &&
                        faqList.map((item, index) => {
                          return (
                            <tr>
                              <td>
                                <p className="faq_para">{item?.question}</p>
                              </td>

                              <td>
                                <p className="faq_para">
                                  <ReactReadMoreReadLess charLimit={100}>
                                    {item?.answer}
                                  </ReactReadMoreReadLess>
                                </p>
                              </td>

                              <td>
                                {moment(item?.created_at).format(
                                  "MMMM D, YYYY"
                                )}
                              </td>

                              <td>
                                <h6
                                  className={
                                    item?.status === "inactive"
                                      ? "disable_var"
                                      : "enable_var"
                                  }
                                >
                                  <img
                                    src={"/assets/images/enablecheck.svg"}
                                    alt=""
                                  />
                                  {item?.status}
                                </h6>
                              </td>

                              <td>
                                <div className="viewProf_flex">
                                  <Button
                                    onClick={() => {
                                      history("/variantfaqedit", {
                                        state: {
                                          id: item?.id,
                                          question: item?.question,
                                          answer: item?.answer,
                                          sequence: item?.sequence,
                                          status: item?.status,
                                        },
                                      });
                                    }}
                                    className="edit_btn edit_btn_nomar"
                                  >
                                    <img
                                      src={"/assets/images/editpurple.svg"}
                                      className="healeyeblue"
                                      alt=""
                                    />
                                    <img
                                      src={"/assets/images/editwhite.svg"}
                                      className="healeyewhite"
                                      alt=""
                                    />
                                    Edit
                                  </Button>

                                  <Button className="del_user">
                                    {item?.status === "active"
                                      ? "Disable"
                                      : "Enable"}
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AdminFooter />
    </>
  );
}
